const initialState = {
    name: '',
}

const UsuarioReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_USUARIO":
            return { ...state, 
                name: action.payload.name }
            //break;
        default:
            break;
    }

    return state;
}

export default UsuarioReducer;